import { Navigate, useLocation, useParams } from "react-router-dom";
import { useBookingStore } from "../../stores/bookingStore";

/**
 * Legacy keyless `/:identifier/confirmation` entry. The canonical confirmation
 * route is keyed (`/confirmation/:reservationKey`); this shim redirects any
 * remaining keyless hit (in-flight sessions, bookmarks) to the keyed URL using
 * the stored key, or home when there's no reservation to show.
 */
export const ConfirmationRedirect = () => {
  const { identifier } = useParams<{ identifier: string }>();
  const location = useLocation();
  const storedKey = useBookingStore((s) => s.reservationKey);

  const target = storedKey
    ? `/${identifier}/confirmation/${storedKey}`
    : `/${identifier}`;

  return <Navigate to={target} replace state={location.state} />;
};

export default ConfirmationRedirect;
